import _ from 'lodash'
import { takeLatest, takeEvery, put, call, select } from 'redux-saga/effects'

import values from 'core/data-model/constants/values'
import { validateTotalPremium } from 'core/service/basic-plan'
import { totalRiderPremium, calculateTotalPremium } from 'core/service/basic-plan/premium'
import { calculateRiderPremiumSelectedPlanGroup } from 'core/service/rider/premium-calculation'
import { isRiderBelongToRpudr } from 'core/service/rider/rider'
import { isInvestment } from 'identity/fse-branch/services'
import { getUserAgentType, getValidUserLicenses } from 'identity/selectors'
import { getToggles } from 'quick-quote/feature-toggles'
import {
  SELECT_GENDER,
  SELECT_PAYER_GENDER,
  UPDATE_BIRTHDATE,
  UPDATE_PAYER_BIRTHDATE,
  SELECT_NATURE_OF_DUTY,
  SELECT_OTHER_NATURE_OF_DUTY,
  SELECT_PAYER_NATURE_OF_DUTY,
  SELECT_PAYER_OTHER_NATURE_OF_DUTY,
  TOGGLE_OTHER_OCCUPATION,
  TOGGLE_PAYER_OTHER_OCCUPATION,
  EDIT_TITLE_NAME,
  validateInsuredInformation,
  SELECT_PAYER_RELATION,
} from 'quick-quote/insured-information/actions'
import {
  getInsured,
  getAge,
  getPayerAge,
  getPayerGender,
  getAllNatureOfDutyCodes,
  getAllPayerNatureOfDutyCodes,
  getPayerRelation,
} from 'quick-quote/insured-information/selectors'
import {
  UPDATE_AVAILABLE_RIDERS,
  EDIT_RIDER_PREMIUM,
  EDIT_RIDER_MODULE_PREMIUM,
  EDIT_BASIC_PREMIUM_STATE,
  EDIT_SUM_ASSURED,
  SELECT_MODEL_FACTOR,
  TOGGLE_RIDER,
  TOGGLE_RIDER_MODULE,
  TOGGLE_RIDER_GROUP_MODULE,
  EDIT_RIDER_SUM_ASSURED,
  EDIT_RIDER_SELECTED_PLAN,
  updateTotalPremium,
  updateTotalRiderPremium,
  updateSumAssured,
  updateBasicPremium,
  updateFullBasicPremium,
  updatFullAnnualBasicPremium,
  updateCampaignDiscountMessage,
  updateCampaignDiscountEndDate,
  editBasicPremiumState,
  updateBasicPremiumState,
  editRiderSumAssured,
  editRiderSelectedPlan,
  editRiderSelectedPlanGroup,
  editRiderPremium,
  editRiderModulePremium,
  updateAvailableRiders,
  updateRidersBenefits,
  EDIT_PENSION_TYPE_STATE,
} from 'quick-quote/product-common/coverage-plan/actions'
import {
  getBasicPremium$,
  getSumAssured$,
  getSelectedModelFactorValue,
  getSelectedModelFactorPeriod,
  getSelectedModelFactorID,
  getAvailableRiders,
  hasMHPRiderAvailableRider,
  getRiderInAvailableRider,
  getAvaliableOptionByAge,
  getSelectedModelFactor,
  getActualRiderPlanCodeWithPackageRiderByAge,
} from 'quick-quote/product-common/coverage-plan/selectors'
import {
  getRiderSelectedPlanCodeMHP,
  getSelectedPlanCodeRiderMultiPlanCodeMHP,
} from 'quick-quote/product-ihealthy-ultra/coverage-plan/selectors'
import {
  SELECT_MODEL_FACTOR as INVESTMENT_SELECT_MODEL_FACTOR,
  EDIT_SUM_ASSURED as INVESTMENT_EDIT_SUM_ASSURED,
  UPDATE_SUM_ASSURED as INVESTMENT_UPDATE_SUM_ASSURED,
  updateRegularPremium,
  updateSumAssured as investmentUpdateSumAssured,
} from 'quick-quote/product-investment/coverage-plan/actions'
import { filterTPDRiderErrorForUdr } from 'quick-quote/product-investment/coverage-plan/sagas'
import {
  getSelectedModelFactorID as getInvestmentSelectedModelFactorID,
  getSelectedModelFactorPeriod as getInvestmentSelectedModelFactorPeriod,
  getSelectedModelFactorILPValue,
  getRegularPremium,
  getSumAssured,
} from 'quick-quote/product-investment/coverage-plan/selectors'
import { editMRTASumAssuredContract, updateCodeInSelectedDisplayProduct } from 'quick-quote/product-mrta/actions'
import {
  getLoanPeriod,
  getCoveragePeriod,
  getLoanAmount,
  getLoan,
  getInterestRateValue,
  isGLTSPGroup,
  isMRTAGroup,
  getGLTSPPlancode,
} from 'quick-quote/product-mrta/coverage-plan/selectors'
import { UPDATE_SUM_ASSURED_AFTER_SELECTED_PLAN_PA } from 'quick-quote/product-pa/actions'
import { SELECT_PRODUCT } from 'quick-quote/product-selection/actions'
import { getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'

export function* updateCoveragePlanState(newValue) {
  yield put(updateSumAssured(newValue.validatedSumAssured))
  yield put(updateTotalPremium(newValue.totalPremium))
  yield put(updateTotalRiderPremium(newValue.riderPremium))

  if (newValue.sumAssuredContract) {
    yield put(editMRTASumAssuredContract(Number(newValue.sumAssuredContract)))
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    if (isGLTSPGroup(displayProductQuery.code)) {
      const GLTSPPlancode = getGLTSPPlancode(displayProductQuery.productPlanCode, newValue.sumAssuredContract)
      yield put(updateCodeInSelectedDisplayProduct(GLTSPPlancode))
    }
  }

  if (newValue.campaignDiscountMessage) {
    yield put(updateCampaignDiscountMessage(newValue.campaignDiscountMessage))
  } else {
    yield put(updateCampaignDiscountMessage([]))
  }
  if (newValue.campaignDiscountEndDate) {
    yield put(updateCampaignDiscountEndDate(newValue.campaignDiscountEndDate))
  } else {
    yield put(updateCampaignDiscountEndDate(''))
  }

  if (newValue.fullBasicPremium) {
    yield put(updateFullBasicPremium(newValue.fullBasicPremium))
  }

  if (newValue.fullAnnualBasicPremium) {
    yield put(updatFullAnnualBasicPremium(newValue.fullAnnualBasicPremium))
  }

  const table = newValue.validatedRiders.reduce((accumulator, current) => {
    if (current) {
      accumulator[current.code] = current
    }
    return accumulator
  }, {})

  yield put(updateBasicPremium(newValue.basicPremium))

  const basicPlanCode = _.get(newValue, 'validatedSumAssured.dependencies.basicPlan.code', '')
  if (basicPlanCode === values.RPUDR) {
    const filter = filterTPDRiderErrorForUdr(table)
    yield put(updateAvailableRiders(filter))
  } else {
    yield put(updateAvailableRiders(table))
  }
}

/**
 * createProductCommonCoverageFunc
 * @param {ReturnType<import('core/service/basic-plan/basic-plan').createBasicPlanService>} basicPlanService
 * @param {ReturnType<import('core/service/basic-plan/premium').createBasicPlanPremiumService>} basicPlanPremiumService
 * @param {ReturnType<import('core/service/basic-plan/validation').createBasicPlanValidationService>} basicPlanValidationService
 * @param {Awaited<ReturnType<import('core/service/rider/rider').createRiderService>>} riderService
 * @param {Awaited<ReturnType<import('core/service/rider/premium-rate').createRiderPremiumRateService>>} riderPremiumRateService
 * @param {ReturnType<import('core/service/display-product/display-product').createDisplayProductService>} displayProductService
 * @param {ReturnType<import('core/service/insured/occupation').createInsuredOccupationService>} insuredOccupationService
 * @param {ReturnType<import('core/service/investment/coverage/validation').createInvestmentCoverageValidateService>} investmentCoverageValidationService
 */
export function createProductCommonCoverageFunc(
  basicPlanService,
  basicPlanPremiumService,
  basicPlanValidationService,
  riderService,
  riderPremiumRateService,
  displayProductService,
  insuredOccupationService,
  investmentCoverageValidationService
) {
  const dispatchEditRiderSumAssured = function(rider, basicSumAssured, basicPremium, basicPlan, userAgentType) {
    const riderSumAssured = riderService.getRiderSumAssured(
      rider,
      basicSumAssured.value,
      basicPremium.value,
      basicPlan,
      userAgentType
    )
    return put(editRiderSumAssured(rider.code, riderSumAssured))
  }

  function* updateDefaultRiderSumAssured(action) {
    const canProceedToCoveragePlanBoolean = yield select(canProceedToCoveragePlan)
    if (!canProceedToCoveragePlanBoolean) {
      return
    }
    const basicSumAssured = yield select(getSumAssured$)
    const basicPremium = yield select(getBasicPremium$)
    const riderCode = action.payload.code
    const riders = yield select(getAvailableRiders)
    const selectedRiders = riders.filter((rider) => rider.code === riderCode).filter(({ isSelected }) => isSelected)
    if (selectedRiders.length === 0) {
      yield call(revalidateRiders)
    } else {
      const displayProductQuery = yield select(getSelectedDisplayProductQuery)
      const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
      const userAgentType = yield call(getUserAgentType)
      yield selectedRiders.map((rider) => {
        return dispatchEditRiderSumAssured(rider, basicSumAssured, basicPremium, basicPlan, userAgentType)
      })
    }
  }

  function* updateTotalPremiumState(action) {
    const sumAssured$ = yield select(getSumAssured$)
    const modelFactorID = yield select(getSelectedModelFactorID)
    const availableRiders = yield select(getAvailableRiders)
    const basicPremium$ = yield select(getBasicPremium$)
    const riderPremium = yield call(totalRiderPremium, availableRiders)
    const totalPremium = yield call(calculateTotalPremium, basicPremium$.value, riderPremium)
    const validatedTotalPremium = validateTotalPremium(
      { basicSumAssured: sumAssured$.value, modelFactorID },
      totalPremium
    )
    yield put(updateTotalPremium(validatedTotalPremium))
    yield put(updateTotalRiderPremium(riderPremium))
    yield put(updateRidersBenefits(availableRiders))
  }

  function* onCalculatePremium(action) {
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const sumAssured$ = isInvestment(basicPlan.category) ? yield select(getSumAssured) : yield select(getSumAssured$)

    // $FlowFixMe
    yield call(generateCoveragePlanFromSumAssuredChange, { payload: sumAssured$.value, type: action.type })
  }

  function* generateCoveragePlanFromPremiumChange(action) {
    const basicPremium = action.payload
    if (basicPremium < 0) {
      return
    }
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const modelFactorID = isInvestment(basicPlan.category)
      ? yield select(getInvestmentSelectedModelFactorID)
      : yield select(getSelectedModelFactorID)
    const availableRiders = yield select(getAvailableRiders)
    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const userAgentType = yield select(getUserAgentType)
    const payerRelation = yield select(getPayerRelation)
    const loanPeriod = yield select(getLoanPeriod)
    const loanAmount = yield select(getLoanAmount)
    const coveragePeriod = yield select(getCoveragePeriod)
    const loan = yield select(getLoan)
    const interestRate = yield select(getInterestRateValue)
    let newValue = yield call(basicPlanService.calculateCoveragePlanFromPremium, {
      basicPremium,
      basicPremiumState: basicPremium,
      displayProductQuery,
      insured,
      natureOfDutyCodes,
      payerNatureOfDutyCodes,
      modelFactorID,
      availableRiders,
      payerAge,
      payerGender,
      userAgentType,
      payerRelation,
      loanPeriod,
      coveragePeriod,
      loanAmount,
      loan,
      interestRate,
    })
    yield call(updateCoveragePlanState, newValue)
  }

  function* generateCoveragePlanFromSumAssuredChange(action) {
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const sumAssured = parseInt(action.payload)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const modelFactorID = isInvestment(basicPlan.category)
      ? yield select(getInvestmentSelectedModelFactorID)
      : yield select(getSelectedModelFactorID)
    const availableRiders = yield select(getAvailableRiders)
    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const userAgentType = yield select(getUserAgentType)
    const payerRelation = yield select(getPayerRelation)
    const loanPeriod = yield select(getLoanPeriod)
    const loanAmount = yield select(getLoanAmount)
    const coveragePeriod = yield select(getCoveragePeriod)
    const loan = yield select(getLoan)
    const interestRate = yield select(getInterestRateValue)

    const newValue = yield call(basicPlanService.calculateCoveragePlanFromSumAssured, {
      sumAssured,
      displayProductQuery,
      insured,
      natureOfDutyCodes,
      payerNatureOfDutyCodes,
      modelFactorID,
      availableRiders,
      payerAge,
      payerGender,
      userAgentType,
      payerRelation,
      loanPeriod,
      coveragePeriod,
      loanAmount,
      loan,
      interestRate,
    })
    yield put(editBasicPremiumState(-1))
    if (
      newValue.fullBasicPremium &&
      newValue.basicPremium !== newValue.fullBasicPremium &&
      !isInvestment(basicPlan.category) &&
      !isMRTAGroup(displayProductQuery.code) &&
      !isGLTSPGroup(displayProductQuery.code)
    ) {
      yield put(updateBasicPremiumState(newValue.fullBasicPremium))
    }
    yield call(updateCoveragePlanState, newValue)
  }

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Rider
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function* populateAvailableRiders() {
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const modelFactorID = isInvestment(basicPlan.category)
      ? yield select(getInvestmentSelectedModelFactorID)
      : yield select(getSelectedModelFactorID)

    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const userAgentType = yield select(getUserAgentType)

    const insuredAge = yield select(getAge)
    const userLicenses = yield select(getValidUserLicenses)
    const payerRelation = yield select(getPayerRelation)
    const loanPeriod = yield select(getLoanPeriod)
    const loanAmount = yield select(getLoanAmount)
    const interestRate = yield select(getInterestRateValue)
    const coveragePeriod = yield select(getCoveragePeriod)
    const loan = yield select(getLoan)
    const newValue = yield call(basicPlanService.populateInitialCoveragePlan, {
      displayProductQuery,
      insured,
      natureOfDutyCodes,
      payerNatureOfDutyCodes,
      modelFactorID,
      payerAge,
      payerGender,
      userAgentType,
      userLicenses,
      payerRelation,
      loanPeriod,
      coveragePeriod,
      loanAmount,
      loan,
      interestRate,
    })

    if (
      newValue.fullBasicPremium &&
      newValue.basicPremium !== newValue.fullBasicPremium &&
      !isInvestment(basicPlan.category) &&
      !isMRTAGroup(displayProductQuery.code) &&
      !isGLTSPGroup(displayProductQuery.code)
    ) {
      yield put(updateBasicPremiumState(newValue.fullBasicPremium))
    }

    if ([values.RPUL, values.RPUDR].includes(displayProductQuery.code)) {
      const validatedRegularPremium = yield call(
        investmentCoverageValidationService.validateRegularPremium,
        displayProductQuery,
        modelFactorID,
        values.DEFAULT_RPP,
        insured.age
      )

      yield put(updateRegularPremium(values.DEFAULT_RPP, validatedRegularPremium.getAllMessages()))

      if (getToggles().ENABLE_MAXIMUM_SUM_ASSURED_CALCULATION_RPUL) {
        const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
        const occupationFactor = yield call(
          insuredOccupationService.getRiskiestOccupation,
          displayProductQuery,
          natureOfDutyCodes
        )

        const payload = {
          regularPremium: values.DEFAULT_RPP,
          insuredAge: insuredAge,
          insuredGender: insured.gender,
          occupationFactor: occupationFactor,
        }

        if (validatedRegularPremium.getAllMessages() && validatedRegularPremium.getAllMessages().length === 0) {
          const maximumSumAssured = yield call(
            investmentCoverageValidationService.getMaximumSumAssured,
            displayProductQuery,
            modelFactorID,
            payload
          )

          const payloadSumAssuredValidation = {
            sumAssured: maximumSumAssured,
            regularPremium: values.DEFAULT_RPP,
            insuredAge: insuredAge,
            insuredGender: insured.gender,
            occupationFactor: occupationFactor,
          }
          const validatedSumAssured = yield call(
            investmentCoverageValidationService.validateSumAssured,
            displayProductQuery,
            modelFactorID,
            payloadSumAssuredValidation
          )
          yield put(investmentUpdateSumAssured(maximumSumAssured, validatedSumAssured.getAllMessages()))
        } else {
          yield put(investmentUpdateSumAssured(0, []))
        }
      }
    }
    yield call(updateCoveragePlanState, newValue)
    yield put(validateInsuredInformation())
  }

  function* revalidateRiders() {
    // need to change here

    const canProceedToCoveragePlanBoolean = yield select(canProceedToCoveragePlan)
    const hasMHP = yield select(hasMHPRiderAvailableRider)
    const insuredAge = yield select(getAge)

    const riderMCI = yield select(getRiderInAvailableRider(values.MCI))
    if (riderMCI && riderMCI.selectedPlan && riderMCI.selectedPlan.planCode) {
      const displayOptions = getAvaliableOptionByAge(riderMCI, insuredAge)
      const selectedPlan = _.find(displayOptions, { planCode: riderMCI.selectedPlan.planCode })
      if (!selectedPlan) {
        const hasDefaultRiderPlanInOptions = _.find(displayOptions, { planCode: riderMCI.defaultRiderPlanCode })
        const updatedSelectedPlan = _.find(riderMCI.options[0].values, {
          planCode: hasDefaultRiderPlanInOptions ?? displayOptions[0].planCode,
        })
        if (updatedSelectedPlan) {
          yield put(editRiderSumAssured(riderMCI.code, updatedSelectedPlan.value))
          yield put(
            editRiderSelectedPlan(riderMCI.code, {
              planCode: updatedSelectedPlan.planCode,
              text: updatedSelectedPlan.text,
            })
          )
        }
      }
    }

    const availableRiders$ = yield select(getAvailableRiders)
    const insured = yield select(getInsured)
    const payerRelation = yield select(getPayerRelation)
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)

    const payerAge = yield select(getPayerAge)

    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)

    const sumAssured$ = isInvestment(basicPlan.category) ? yield select(getSumAssured) : yield select(getSumAssured$)

    if (hasMHP) {
      const selectedPlan = getSelectedPlanCodeRiderMultiPlanCodeMHP(availableRiders$, insured)
      const currRiderSelectedPlanCode = getRiderSelectedPlanCodeMHP(availableRiders$)
      if (selectedPlan.planCode !== currRiderSelectedPlanCode) yield put(editRiderSelectedPlan('MHP', selectedPlan))
    }
    const loan = yield select(getLoan)
    const userAgentType = yield select(getUserAgentType)

    const riderCIES = yield select(getRiderInAvailableRider(values.CIES))
    if (
      riderCIES &&
      riderCIES.selectedPlan &&
      riderCIES.selectedPlan.planCode &&
      riderCIES.isSelected &&
      riderCIES.isSelectable
    ) {
      const payerGender = yield select(getPayerGender)
      const basicPremium = yield select(getBasicPremium$)
      const actualRiderPlanCode = getActualRiderPlanCodeWithPackageRiderByAge(riderCIES, insuredAge)
      if (riderCIES.selectedPlan.planCode !== actualRiderPlanCode)
        yield put(editRiderSelectedPlan(riderCIES.code, { planCode: actualRiderPlanCode }))

      const _availableRiders = yield select(getAvailableRiders)
      const riderPremiumRates = yield call(
        riderPremiumRateService.getRiderPremiumRates,
        insured.age,
        payerAge,
        insured.gender,
        payerGender,
        _availableRiders,
        natureOfDutyCodes,
        displayProductQuery
      )
      const riderOccupationFactors = yield call(
        insuredOccupationService.getRiskiestOccupationFactorForRiders,
        displayProductQuery,
        natureOfDutyCodes,
        _availableRiders
      )
      const riderPayerOccupationFactors = yield call(
        insuredOccupationService.getRiskiestOccupationFactorForRiders,
        displayProductQuery,
        payerNatureOfDutyCodes,
        _availableRiders
      )
      const modelFactor = isInvestment(basicPlan.category)
        ? yield select(getSelectedModelFactorILPValue)
        : yield select(getSelectedModelFactorValue)
      const modelFactorPeriod = isInvestment(basicPlan.category)
        ? yield select(getInvestmentSelectedModelFactorPeriod)
        : yield select(getSelectedModelFactorPeriod)

      const _riderCIES = yield select(getRiderInAvailableRider(values.CIES))
      const selectedPlanGroup = calculateRiderPremiumSelectedPlanGroup(
        riderPremiumRates,
        _riderCIES,
        riderOccupationFactors,
        basicPremium,
        modelFactor,
        modelFactorPeriod,
        riderPayerOccupationFactors,
        loan,
        userAgentType
      )
      yield put(editRiderSelectedPlanGroup(riderCIES.code, selectedPlanGroup))
    }

    const availableRiders = yield select(getAvailableRiders)
    const modelFactor = yield select(getSelectedModelFactor)
    // $FlowFixMe
    const updatedAvailableRiders = yield call(
      riderService.validateRiders,
      availableRiders,
      insured,
      payerAge,
      sumAssured$.value,
      natureOfDutyCodes,
      payerNatureOfDutyCodes,
      displayProductQuery,
      payerRelation,
      loan,
      userAgentType,
      modelFactor
    )

    const table = updatedAvailableRiders.reduce((accumulator, current) => {
      accumulator[current.code] = current
      return accumulator
    }, {})

    if (basicPlan.code === values.RPUDR) {
      const shouldUpdateRider = updatedAvailableRiders.some(isRiderBelongToRpudr)
      if (shouldUpdateRider) {
        yield put(updateAvailableRiders(table))
      }
    } else {
      yield put(updateAvailableRiders(table))
    }
  }

  function* updateRiderSelectedPlan(action) {
    const canProceedToCoveragePlanBoolean = yield select(canProceedToCoveragePlan)
    if (!canProceedToCoveragePlanBoolean) {
      return
    }

    const riders = yield select(getAvailableRiders)
    const riderCode = action.payload.riderCode
    const selectedRider = _(riders)
      .filter({ code: riderCode })
      .filter('isSelected')
      .value()
    if (selectedRider.length === 0) {
      yield call(revalidateRiders)
    } else {
      const displayProductQuery = yield select(getSelectedDisplayProductQuery)
      const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)

      const sumAssured$ = isInvestment(basicPlan.category)
        ? yield select(getRegularPremium)
        : yield select(getSumAssured$)

      const userAgentType = yield call(getUserAgentType)
      const insuredAge = yield select(getAge)

      yield selectedRider.map((rider) => {
        return dispatchEditRiderSelectedPlan(rider, basicPlan, sumAssured$.value, userAgentType, insuredAge)
      })
    }
  }

  function* updateRiderPremium(action) {
    const canProceedToCoveragePlanBoolean = yield select(canProceedToCoveragePlan)
    if (!canProceedToCoveragePlanBoolean) {
      return
    }
    const riderCode = action.payload.code
    const riders = yield select(getAvailableRiders)
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)
    const riderPremiumRates = yield call(
      riderPremiumRateService.getRiderPremiumRates,
      insured.age,
      payerAge,
      insured.gender,
      payerGender,
      riders,
      natureOfDutyCodes,
      displayProductQuery
    )

    const riderOccupationFactors = yield call(
      insuredOccupationService.getRiskiestOccupationFactorForRiders,
      displayProductQuery,
      natureOfDutyCodes,
      riders
    )
    const riderPayerOccupationFactors = yield call(
      insuredOccupationService.getRiskiestOccupationFactorForRiders,
      displayProductQuery,
      payerNatureOfDutyCodes,
      riders
    )
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const basicPremium = yield select(getBasicPremium$)

    const loan = yield select(getLoan)

    const modelFactor = isInvestment(basicPlan.category)
      ? yield select(getSelectedModelFactorILPValue)
      : yield select(getSelectedModelFactorValue)

    const modelFactorPeriod = isInvestment(basicPlan.category)
      ? yield select(getInvestmentSelectedModelFactorPeriod)
      : yield select(getSelectedModelFactorPeriod)

    const userAgentType = yield select(getUserAgentType)

    const selectedRiders = _(riders)
      .filter({ code: riderCode })
      .filter('isSelected')
      .value()

    if (selectedRiders.length === 0) {
      yield call(revalidateRiders)
    }

    yield _(selectedRiders)
      .value()
      .map((rider) => {
        return dispatchEditRiderPremium(
          riderPremiumRates,
          rider,
          riderOccupationFactors,
          basicPremium,
          modelFactor,
          modelFactorPeriod,
          riderPayerOccupationFactors,
          loan,
          userAgentType
        )
      })

    yield _(selectedRiders)
      .filter('selectedPlan.modules')
      .value()
      .map((rider) => {
        return _(rider.selectedPlan.modules)
          .filter('isSelected')
          .value()
          .map((m) => {
            return dispatchEditRiderModulePremium(
              riderPremiumRates,
              rider,
              m.code,
              riderOccupationFactors,
              basicPremium,
              modelFactor,
              modelFactorPeriod,
              riderPayerOccupationFactors,
              userAgentType
            )
          })
      })
  }

  const dispatchEditRiderPremium = function(
    riderPremiumRates,
    rider,
    riderOccupationFactors,
    basicPremium,
    modelFactor,
    modelFactorPeriod,
    riderPayerOccupationFactors,
    loan,
    userAgentType
  ) {
    const riderPremiumRate = riderPremiumRates[rider.code]
    const riderSumAssured = rider.sumAssured
    const occupationFactor = riderOccupationFactors[rider.code]
    const payerOccupationFactor = riderPayerOccupationFactors[rider.code]
    const allDependencies = {
      riderPremiumRate,
      occupationFactor,
      riderSumAssured,
      basicPremium: basicPremium.value,
      modelFactor,
      modelFactorPeriod,
      payerOccupationFactor,
      loan,
      userAgentType,
      riderPremiumRates,
    }

    const riderPremium = riderService.calculateRiderPremium(rider, allDependencies)
    return put(editRiderPremium(rider.code, riderPremium))
  }

  const dispatchEditRiderModulePremium = function(
    riderPremiumRates,
    rider,
    riderModuleCode,
    riderOccupationFactors,
    basicPremium,
    modelFactor,
    modelFactorPeriod,
    riderPayerOccupationFactors,
    userAgentType
  ) {
    const riderPremiumRate = riderPremiumRates[riderModuleCode]
    const riderSumAssured = rider.sumAssured
    const occupationFactor = riderOccupationFactors[rider.code]
    const payerOccupationFactor = riderPayerOccupationFactors[rider.code]
    const allDependencies = {
      riderPremiumRate,
      occupationFactor,
      riderSumAssured,
      basicPremium: basicPremium.value,
      modelFactor,
      modelFactorPeriod,
      payerOccupationFactor,
      userAgentType,
      riderPremiumRates,
    }

    const riderPremium = riderService.calculateRiderPremium(rider, allDependencies)
    return put(editRiderModulePremium(rider.code, riderModuleCode, riderPremium))
  }

  const dispatchEditRiderSelectedPlan = function(rider, basicPlan, sumAssured, userAgentType, insuredAge) {
    const selectedPlan = riderService.getSelectedRiderPlan(
      rider,
      rider.selectedPlan,
      basicPlan,
      sumAssured,
      userAgentType,
      undefined,
      undefined,
      insuredAge
    )
    return put(editRiderSelectedPlan(rider.code, selectedPlan))
  }

  //TODO: must write unit testing on this function
  function* updateAllSelectedRiderPremium() {
    const canProceedToCoveragePlanBoolean = yield select(canProceedToCoveragePlan)
    if (!canProceedToCoveragePlanBoolean) {
      return
    }
    const riders = yield select(getAvailableRiders)
    const displayProductQuery = yield select(getSelectedDisplayProductQuery)
    const natureOfDutyCodes = yield select(getAllNatureOfDutyCodes)
    const insured = yield select(getInsured)
    const payerAge = yield select(getPayerAge)
    const payerGender = yield select(getPayerGender)
    const payerNatureOfDutyCodes = yield select(getAllPayerNatureOfDutyCodes)

    const riderPremiumRates = yield call(
      riderPremiumRateService.getRiderPremiumRates,
      insured.age,
      payerAge,
      insured.gender,
      payerGender,
      riders,
      natureOfDutyCodes,
      displayProductQuery
    )
    const riderOccupationFactors = yield call(
      insuredOccupationService.getRiskiestOccupationFactorForRiders,
      displayProductQuery,
      natureOfDutyCodes,
      riders
    )

    const riderPayerOccupationFactors = yield call(
      insuredOccupationService.getRiskiestOccupationFactorForRiders,
      displayProductQuery,
      payerNatureOfDutyCodes,
      riders
    )
    const basicPlan = yield call(displayProductService.getBasicPlan, displayProductQuery)
    const loan = yield select(getLoan)

    const modelFactor = isInvestment(basicPlan.category)
      ? yield select(getSelectedModelFactorILPValue)
      : yield select(getSelectedModelFactorValue)

    const basicPremium = yield select(getBasicPremium$)

    const modelFactorPeriod = isInvestment(basicPlan.category)
      ? yield select(getInvestmentSelectedModelFactorPeriod)
      : yield select(getSelectedModelFactorPeriod)

    const userAgentType = yield select(getUserAgentType)

    yield riders
      .filter(({ isSelected }) => isSelected)
      .map((rider) => {
        return dispatchEditRiderPremium(
          riderPremiumRates,
          rider,
          riderOccupationFactors,
          basicPremium,
          modelFactor,
          modelFactorPeriod,
          riderPayerOccupationFactors,
          loan,
          userAgentType
        )
      })
  }

  return {
    updateCoveragePlanState,
    updateDefaultRiderSumAssured,
    updateTotalPremiumState,
    onCalculatePremium,
    generateCoveragePlanFromPremiumChange,
    generateCoveragePlanFromSumAssuredChange,
    populateAvailableRiders,
    revalidateRiders,
    updateRiderSelectedPlan,
    updateRiderPremium,
    updateAllSelectedRiderPremium,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { COMMON } = serviceWrapper.products

  const CALCULATE_PREMIUM_ACTION_TRIGGERS = [
    SELECT_GENDER,
    SELECT_NATURE_OF_DUTY,
    SELECT_OTHER_NATURE_OF_DUTY,
    SELECT_PAYER_NATURE_OF_DUTY,
    SELECT_PAYER_OTHER_NATURE_OF_DUTY,
    TOGGLE_PAYER_OTHER_OCCUPATION,
    TOGGLE_OTHER_OCCUPATION,
    UPDATE_BIRTHDATE,
    UPDATE_PAYER_BIRTHDATE,
    SELECT_MODEL_FACTOR,
    INVESTMENT_SELECT_MODEL_FACTOR,
    UPDATE_SUM_ASSURED_AFTER_SELECTED_PLAN_PA,
  ]

  const CALCULATE_RIDER_PREMIUM_ACTION_TRIGGERS = [SELECT_PAYER_GENDER]

  yield [
    takeLatest(EDIT_BASIC_PREMIUM_STATE, COMMON.onCalculateFromPremiumChange),
    takeLatest(CALCULATE_PREMIUM_ACTION_TRIGGERS, COMMON.onCalculatePremium),

    takeEvery([EDIT_RIDER_SELECTED_PLAN], COMMON.onEditRiderSelectPlan),
    takeLatest([TOGGLE_RIDER], COMMON.onToggleRider),
    takeLatest([TOGGLE_RIDER_MODULE], COMMON.onToggleRider),
    takeLatest([TOGGLE_RIDER_GROUP_MODULE], COMMON.onToggleRider),

    takeEvery(CALCULATE_RIDER_PREMIUM_ACTION_TRIGGERS, COMMON.updateAllSelectedRiderPremium),
    takeEvery([EDIT_RIDER_SUM_ASSURED], COMMON.onCalculateFromRiderSumAssuredChange),

    takeEvery(
      [EDIT_RIDER_PREMIUM, INVESTMENT_UPDATE_SUM_ASSURED, UPDATE_BIRTHDATE, EDIT_TITLE_NAME],
      COMMON.revalidateRiders
    ),
    takeLatest(EDIT_RIDER_MODULE_PREMIUM, COMMON.revalidateRiders),
    takeLatest(SELECT_PAYER_RELATION, COMMON.revalidateRiders),
    takeLatest(SELECT_PRODUCT, COMMON.populateAvailableRiders),

    takeLatest([EDIT_SUM_ASSURED, INVESTMENT_EDIT_SUM_ASSURED], COMMON.onCalculateFromSumAssuredChange),

    takeLatest([UPDATE_AVAILABLE_RIDERS], COMMON.updateTotalPremiumState),
    takeLatest(EDIT_PENSION_TYPE_STATE, COMMON.onSelectPensionType),
    takeLatest([SELECT_MODEL_FACTOR, INVESTMENT_SELECT_MODEL_FACTOR], COMMON.onSelectModelFactor),
  ]
}

export const sagas = watchers
